import { Component, OnInit } from '@angular/core';
import { BrowserStorageService } from 'src/app/services/storage.service';
@Component({
    selector: 'app-cookies',
    templateUrl: './cookies.component.html',
    styleUrls: ['./cookies.component.scss']
})
export class CookiesComponent implements OnInit {

    constructor(private localStorage: BrowserStorageService) { }

    showPolicyInfo: boolean = false;

    ngOnInit(): void {
        this.isPolicyAccepted();
    }

    public onClose(): void {
        this.showPolicyInfo = false;
        this.localStorage.set('cookie_policy', 'OK');
    }

    private isPolicyAccepted(): void {
        let cookiePolicy = this.localStorage.get('cookie_policy');
        if (cookiePolicy) {
            this.showPolicyInfo = false;
        } else {
            this.showPolicyInfo = true;
        }
    }
}